<template>
  <div class="registrarManage">
    <Registrar ref="Registrar" @done="refresh"/>
    <DelConfirm ref="DelConfirm" @del="del"/>
    <div class="registrar-top">
      <div class="registrar" @click="openModal('add')">
        <i></i>
        <span>{{$t('btn.b27')}}</span>
      </div>
    </div>
    <div>
      <Datatable
        url="/Member/RZJPledge/UserOperatorList"
        :th="[$t('label.w160'),$t('label.w161'),$t('label.w162'),$t('label.w19')]"
        field="OperatorList"
        v-slot="{item}"
        ref="datatable"
        :tip="$t('msg.m110')"
      >
        <tr>
          <td>{{item.OperatorName}}</td>
          <td>{{item.AccountName}}</td>
          <td>{{item.VerifyInfo}}</td>
          <td>
            <Button class="btn" @click="openModal('del',item)">{{$t('btn.b25')}}</Button>
            <Button class="btn" @click="openModal('edit',item)">{{$t('btn.b26')}}</Button>
          </td>
        </tr>
      </Datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import DelConfirm from "@/components/delConfirm";
import Registrar from "./modal/registrar";
export default {
  components: { Datatable, Registrar, DelConfirm },
  methods: {
    openModal(t, v) {
      switch (t) {
        case "add":
          this.$refs.Registrar.info = {};
          this.$refs.Registrar.modal = true;
          break;
        case "edit":
          this.$refs.Registrar.info = v;
          this.$refs.Registrar.modal = true;
          break;
        case "del":
          this.$refs.DelConfirm.text =this.$t('msg.m55');
          this.$refs.DelConfirm.id = v.Id;
          this.$refs.DelConfirm.modal = true;
          break;
      }
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    async del(id) {
      let res=await this.$axios.post('/Member/RZJPledge/DeleteUserOperator',{id})
      res.throw()
      if(!res.err) this.refresh()
    }
  }
};
</script>


<style lang="less" scoped>
.registrarManage {
  margin-top: 30px;
  min-height: 600px;
  .registrar-top {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    .registrar {
      width: 139px;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      background: rgba(94, 143, 252, 1);
      border-radius: 8px;
      cursor: pointer;
      i {
        width: 14px;
        height: 14px;
        background: url("../../assets/assetcenter/domain_binding.png") no-repeat;
        display: inline-block;
        background-size: cover;
        margin-right: 5px;
      }
    }
  }
}
.btn {
  line-height: 30px;
  height: 32px;
  padding: 0 20px;
  border-radius: 6px;
  border: 1px solid rgba(151, 151, 151, 1);
  margin: 0 10px;
}
</style>
